import React from 'react';
import { Grid } from '@mui/material';
import ClosedGift from '@gamiphy/icons/ClosedGift';
import { ThemeStore } from '@gamiphy/loyalty-station-desktop/store/theme';
import Footer from './components/Footer';
import Header from './components/Header';

const WelcomePointsPage: React.FC = () => (
  <Grid
    container
    direction="column"
    sx={(theme) => ({
      background: '#ffffff',
      color: theme.palette.text.secondary,
    })}
  >
    <Grid sx={(theme) => ({
      color: theme.palette.text.primary,
      p: theme.spacing(2),
      fontSize: '2.1rem',
      fontWeight: 500,
    })}
    >
      <Header />
    </Grid>
    <Grid
      container
      direction="column"
      alignItems="center"
      justifyContent="center"
      sx={(theme) => ({
        flex: 2,
        overflow: 'auto',
        p: theme.spacing(2),
      })}
    >
      <Grid
        sx={{
          backgroundPosition: 'center',
          backgroundSize: 'cover',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          maxHeight: '10rem',
        }}
        size={12}
      >
        <ClosedGift color={ThemeStore.theme?.palette?.primary?.main} />
      </Grid>
    </Grid>
    <Grid sx={(theme) => ({
      p: theme.spacing(2),
      fontWeight: 500,
      '& button': {
        color: theme.palette.text.secondary,
        backgroundColor: theme.palette.primary.main,
        '&:hover': {
          backgroundColor: theme.palette.primary.main,
        },
      },
    })}
    >
      <Footer />
    </Grid>
  </Grid>
);

export default WelcomePointsPage;
